<template>
  <footer class="mi-footer">
    <div class="mi-footer-inner">
      <div class="mi-footer-brand">
        <router-link to="/" class="mi-footer-wordmark">MLS Ingest</router-link>
        <span>A Brokurz company · mlsingest.com</span>
      </div>

      <nav class="mi-footer-nav" aria-label="Footer">
        <router-link to="/mls-directory">Directory</router-link>
        <router-link to="/status">Status</router-link>
        <router-link to="/contact">Sales</router-link>
        <router-link to="/announcement">Announcement</router-link>
        <router-link to="/privacy">Privacy</router-link>
        <router-link to="/terms">Terms</router-link>
      </nav>

      <p class="mi-footer-copy">© {{ year }} MLS Ingest. All rights reserved.</p>
    </div>
    <p v-if="note" class="mi-footer-note">{{ note }}</p>
  </footer>
</template>

<script>
export default {
  name: 'MarketingFooter',
  props: {
    note: { type: String, default: '' },
  },
  data() {
    return { year: 2026 }
  },
}
</script>
